<template>
    <div id="pharmacy-list">

        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :agGrid="agGrid" pageTitle="Liste des fournisseurs" @refresh="loadData" />
            </b-card>
        </b-overlay>

    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import BLinkCellRenderer from "./BLinkCellRenderer.vue";
import DropDownCellRenderer from "./DropDownCellRenderer.vue";

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            showLoading: false,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Article",
                        cellRendererFramework: 'bLinkCellRenderer',
                        cellRendererParams: { onButtonClick: this.onButtonClick, },
                    },
                    {
                        headerName: "Code",
                        field: "id",
                    },
                    {
                        headerName: "Username",
                        field: "userAccount",
                    },
                    {
                        headerName: "Raison Sociale",
                        field: "entityName",
                        width: 300
                    },
                    {
                        headerName: "Tél",
                        field: "phone",
                    },
                    {
                        headerName: "E-mail",
                        field: "email",
                    },
                    {
                        headerName: "Type",
                        field: "type",
                    },
                    {
                        headerName: "Adresse",
                        field: "address",
                    },
                    {
                        headerName: "Code Postal",
                        field: "postalCode",
                    },
                    {
                        headerName: "Statut",
                        field: "activated",
                        cellRenderer: params => params.value
                            ? '<span class="badge badge-pill badge-light-success">Actif</span>'
                            : '<span class="badge badge-pill badge-light-danger">Inactif</span>',
                        sortable: true,
                        filter: true,
                    },
                    {
                        headerName: '',
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'dropDownCellRenderer',
                        cellRendererParams: { onButtonClick: this.onVendorClick },
                        sortable: false,
                        resizable: false,
                        filter: false,
                    },
                ],
                rows: []
            },
        }
    },
    computed: {
    },
    created() {
        this.$options.components.bLinkCellRenderer = BLinkCellRenderer;
        this.$options.components.dropDownCellRenderer = DropDownCellRenderer;
        this.loadData();
    },
    methods: {
        async onVendorClick(rowData, action) {
            if (action === "toggleActivate") {
                const isActive = rowData.activated;
                this.$swal({
                    title: (isActive ? 'Désactiver' : 'Activer') + ' ' + rowData.entityName + ' ?',
                    text: isActive ? 'Ce fournisseur ne pourra plus se connecter.' : 'Ce fournisseur pourra à nouveau se connecter.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Oui, confirmer',
                    customClass: {
                        confirmButton: 'btn ' + (isActive ? 'btn-danger' : 'btn-success'),
                        cancelButton: 'btn btn-outline-secondary ml-1',
                    },
                    buttonsStyling: false,
                }).then(async (result) => {
                    if (result.value) {
                        this.showLoading = true;
                        await this.$http.post('account/toggleActivate/' + rowData.userAccount).catch(() => {
                            this.showLoading = false;
                        });
                        await this.loadData();
                    }
                });
            } else if (action === "password") {
                this.$swal({
                    title: 'Modifier le mot de passe de ' + rowData.entityName + ' ?',
                    text: "Vous ne pourrez pas revenir en arrière !",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Oui, modifiez-le !',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1',
                    },
                    buttonsStyling: false,
                }).then(async (result) => {
                    if (result.value) {
                        this.showLoading = true;
                        let response = await this.$http.post("account/modifyPassword/" + rowData.userAccount).catch(() => {
                            this.showLoading = false;
                        });
                        this.$swal({
                            title: 'Mot de passe mis à jour avec succès',
                            text: response.data,
                            icon: 'success',
                            customClass: { confirmButton: 'btn btn-primary' },
                            showClass: { popup: 'animate__animated animate__flipInX' },
                            buttonsStyling: false,
                        });
                        this.showLoading = false;
                    }
                });
            }
        },
        async loadData() {
            this.showLoading = true;
            let response = await this.$http.get("_vendor").catch(() => {
                this.showLoading = false;
            });
            this.agGrid.rows = response.data;
            this.showLoading = false;
        },
        onButtonClick(data) {
            const routeData = this.$router.resolve({ name: 'supervisor-supp-items', params: { code: data.id } });
            window.open(routeData.href, '_blank');
        }
    }
}
</script>

<style lang="scss"></style>
